import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { bonuses } from '../data/bonuses';
import { bonusTotalValue, bonusValue, totalBonuses } from '../data/offer';
export function BonusSection() {
  return <section className="border-y border-slate-800 bg-slate-900 py-16 sm:py-20" aria-labelledby="bonus-title" data-id="element-18" data-mp="1ydi6yabp1vla">
      <div className="mx-auto max-w-4xl px-4" data-id="element-19" data-mp="1annw1yaxqh3o">
        <SectionHeading id="bonus-title" data-id="element-20" data-mp="1amcrhw9o15bi">The {totalBonuses} <span className="text-amber-400" data-id="element-21" data-mp="15q5jzz1mflrg">Exclusive Bonuses</span></SectionHeading>

        <ul className="mt-10 divide-y divide-slate-800 overflow-hidden rounded-xl border border-slate-800 bg-slate-950 shadow-sm" data-id="element-22" data-mp="1jgitw6y2pajf">
          {bonuses.map((bonus, index) => {
          const Icon = bonus.icon;
          return <motion.li key={bonus.title} initial={{
            opacity: 0,
            y: 12
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.28,
            delay: index * 0.04,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex gap-4 p-5 sm:p-6" data-id="element-23" data-mp="qzoi6el2qtu1" data-mpi={index}>
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-orange-500/10 text-orange-400" data-id="element-24" data-mp="2jhcvqxr1pe0v">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-25" data-mp="2ofo6rbt2tuko" />
                </span>
                <div className="min-w-0 flex-1" data-id="element-26" data-mp="1qua9p53k2vri">
                  <p className="text-sm font-semibold text-amber-400" data-id="element-27" data-mp="1qvle974ts7jo">Bonus {bonus.number}</p>
                  <h3 className="mt-1 text-lg font-semibold leading-snug text-white" data-id="element-28" data-mp="1vu50l8nbzlck">{bonus.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-slate-300" data-id="element-29" data-mp="20trdti35t1ld">{bonus.description}</p>
                  <p className="mt-2 text-sm font-semibold" data-id="element-30" data-mp="25o55b9epaokr">
                    <span className="text-slate-500 line-through decoration-2" data-id="element-31" data-mp="3c61xmyzxdndo">{bonusValue}</span>{' '}
                    <span className="text-amber-400" data-id="element-32" data-mp="3h43hhm56dqq7">→ FREE</span>
                  </p>
                </div>
              </motion.li>;
        })}
        </ul>

        <div className="mt-6 flex flex-col items-center justify-between gap-5 rounded-xl border border-amber-400/40 bg-slate-950 px-6 py-6 text-center shadow-sm sm:flex-row sm:text-left" data-id="element-33" data-mp="1c4typfu0a7cg">
          <div data-id="element-34" data-mp="1m2rnc4fs265l">
            <p className="text-sm font-medium text-slate-400" data-id="element-35" data-mp="1m28fxhnr705t">Value of all {totalBonuses} bonuses</p>
            <p className="mt-1 text-3xl font-bold tracking-tight text-slate-500 line-through decoration-2" data-id="element-36" data-mp="yc4dhdmax6ge">
              {bonusTotalValue}
            </p>
          </div>
          <div className="sm:text-right" data-id="element-37" data-mp="1757ntd1nh36t">
            <p className="text-sm font-medium text-slate-400" data-id="element-38" data-mp="17697g5wqey05">Your price today</p>
            <p className="mt-1 inline-flex items-center gap-2 text-4xl font-bold tracking-tight text-amber-400" data-id="element-39" data-mp="12e93m2djjkya">
              <GiftIcon className="h-7 w-7" aria-hidden="true" data-id="element-40" data-mp="envbkbuyhm3p" /> FREE
            </p>
          </div>
        </div>
      </div>
    </section>;
}